import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const LOGO = {
  full: '/assets/logo/vde-full.png',
  // trentennale (1996-2026): il logo "30 anni" sostituisce quello essenziale nel sito
  minimal: '/assets/logo/vde-30-anni.svg',
  minimalLight: '/assets/logo/vde-30-anni-light.svg',
  png: '/assets/logo/vde-30-anni.png',
  // logo del kit stampa (lo ZIP contiene vde-full e vde-essential)
  essential: '/assets/logo/vde-black.png',
};

export const IMG = {
  hero: '/assets/hero.jpg',
  tableware: '/assets/tableware.jpg',
  horeca: '/assets/horeca.webp',
};

export const RETAILER_URL = 'https://www.satur.it';
// Unico profilo social con URL confermato (export Instagram 02/11/2026).
export const INSTAGRAM_URL = 'https://www.instagram.com/vde.villadestehometivoli';

/**
 * Blocco neutro, non un placeholder decorativo: dove manca la foto reale il
 * sito deve mostrare uno spazio dichiaratamente vuoto e correttamente
 * dimensionato, non un segno di brand che finge un contenuto. Le richieste di
 * materiale sono tracciate in ASSETS.md.
 */
export const FALLBACK_IMAGE =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='500' viewBox='0 0 400 500'><rect width='400' height='500' fill='%23EFE9E0'/></svg>";
